import React from "react";
import { STRINGS } from "../../strings";
import { translate } from "../../translate";
import { incorrectSound } from "../../utils/Sounds";
import { TC_TIMES_CIRCLE_SVG } from "../../utils/tc_svgs";
import { AppIcon } from "../Generic/AppIcon";

const TrainingCenterVideoEngagementQuestionResultFail = () => {
  incorrectSound.play();

  return (
    <div className="TrainingCenterVideoEngagementQuestionResultFail">
      <AppIcon icon={TC_TIMES_CIRCLE_SVG} />
      <span>{translate(STRINGS.YOUR_ANSWER_IS_INCORRECT)}</span>
    </div>
  );
};

export default React.memo(TrainingCenterVideoEngagementQuestionResultFail);
